import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'
import { getEndpoints } from '@app/const/config'

const {
  location: { hostname }
} = window
const { backend } = getEndpoints(hostname)

// DEPRECATED - delete usages

export const ApolloClientFetch = (auth, requestName) => {
  const Options = {
    cache: new InMemoryCache({
      addTypename: false
    }),
    link: new HttpLink({
      uri: requestName ? backend.replace(/\/$/, '') + '/' + requestName : backend,
      headers: auth && {
        Authorization: `Bearer ${auth}`
      }
    })
  }
  return new ApolloClient({
    ...Options
  })
}
